// Mirror of App\Enums\SecretaryListType (campdraftone-api) — `type` filter of /v2/secretaries.
// Keep in sync by hand. Labels stay here: it is a filter, not a stored column (no *_label from API).
export const SECRETARY_LIST_TYPE_ALL = 'all'
export const SECRETARY_LIST_TYPE_MEMBER = 'member'
export const SECRETARY_LIST_TYPE_SECRETARY_ONLY = 'secretary_only'
export const SECRETARY_LIST_TYPE_SUPER = 'super'

export const SECRETARY_LIST_TYPE_TABS = [
  { value: SECRETARY_LIST_TYPE_ALL, label: 'All' },
  { value: SECRETARY_LIST_TYPE_MEMBER, label: 'Member Secretary' },
  { value: SECRETARY_LIST_TYPE_SECRETARY_ONLY, label: 'Secretary Only' },
  { value: SECRETARY_LIST_TYPE_SUPER, label: 'Super Secretary' }
]



// WEBPACK FOOTER //
// ./src/constants/secretaryListType.js